import { replaceImgWithAmpImg } from "../lib/image";
import "./HtmlEmbed.style.scss";
import type { HtmlLegacyProps } from "@ihr-radioedit/inferno-core";

export const HtmlEmbedLegacy = ({ html: __html, amp }: HtmlLegacyProps) => {
  if (amp && __html.includes("<img")) {
    __html = replaceImgWithAmpImg(__html);
  }
  return <div className="component-embed-html" dangerouslySetInnerHTML={{ __html }} />;
};

export default HtmlEmbedLegacy;
